"use client";
import { cn } from "@/libs/utils";
import { motion } from "framer-motion";

export default function FlipText({
  children,
  className,
  classNameStyleCustom,
  isHovered,
}: {
  children: string;
  className?: string;
  classNameStyleCustom?: string;
  isHovered?: boolean;
}) {
  const DURATION = 0.25;
  const STAGGER = 0.025;
  const classNameStyle =
    "inline-block bg-gradient-to-r from-[#fff] dark:from-[#509eff] via-[#ffe5e5] dark:via-[#e9e9e9] to-[#ff6a4a] dark:to-[#45c3dc] text-transparent bg-clip-text";

  return (
    <motion.div
      initial="initial"
      className={cn(
        "relative block overflow-hidden whitespace-nowrap",
        className
      )}
      {...(isHovered === undefined
        ? { whileHover: "hovered" }
        : { animate: isHovered ? "hovered" : "initial" })}
    >
      <div className="">
        {children.split("").map((l, i) => (
          <motion.span
            variants={{
              initial: { y: 0 },
              hovered: { y: "-100%" },
            }}
            transition={{
              duration: DURATION,
              ease: "easeInOut",
              delay: STAGGER * i,
            }}
            className={classNameStyleCustom ?? classNameStyle}
            key={i}
          >
            {l}
          </motion.span>
        ))}
      </div>
      <div className="absolute inset-0">
        {children.split("").map((l, i) => (
          <motion.span
            variants={{
              initial: { y: "100%" },
              hovered: { y: 0 },
            }}
            transition={{
              duration: DURATION,
              ease: "easeInOut",
              delay: STAGGER * i,
            }}
            className={classNameStyleCustom ?? classNameStyle}
            key={i}
          >
            {l}
          </motion.span>
        ))}
      </div>
    </motion.div>
  );
}
